


















































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import { ETemplateType, IBatchTemplate } from '@zunta/configurations/dist/types/template'
import { ETemplateLevel, ITemplate } from '@zunta/configurations'
import { TemplateModule } from '@/store/modules/template.module'
import { getModule } from 'vuex-module-decorators'
import ConditionsModal from '@/views/app/management/mailings/components/ConditionsModal.vue'
import FileInput from '@/components/inputs/FileInput.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { NoCache } from '@/decorators/NoCache'

@Component({
  components: { ConditionsModal, Icon, Select, FileInput },
  props: {
    facilityId: {
      type: [String, Number],
      required: true
    },
    settingsId: {
      type: [String, Number]
    },
    templateOptions: {
      required: true
    },
    enableBulkSave: {
      default: false
    },
    payerTypes: {
      type: Array
    }
  }
})
export default class BatchTemplatesForm extends Vue {
  letterConditionModal: boolean = false
  selectedTemplate: object = {}
  emptyLetterObj: any = {
    id: null,
    facilityId: this.$props.facilityId,
    batchId: null,
    settingsId: this.$props.settingsId ? this.$props.settingsId : null,
    template: null,
    type: ETemplateType.LETTER_PDF
  }
  emptyMessageObj: any = {
    id: null,
    facilityId: this.$props.facilityId,
    batchId: null,
    settingsId: this.$props.settingsId ? this.$props.settingsId : null,
    template: null,
    type: ETemplateType.MESSAGE
  }
  letterTemplatesList: Partial<IBatchTemplate>[] = []
  messageTemplatesList: Partial<IBatchTemplate>[] = []
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  ADD_LETTER_TRIGGER_VALUE: string = ETemplateType.LETTER_PDF
  ADD_MESSAGE_TRIGGER_VALUE: string = ETemplateType.MESSAGE
  APP_URL: string = process.env.VUE_APP_APP_URL
  isLoadingFile: boolean = false
  fileName: string = ''

  async getBatchSettingsTemplates (settingsId: number | string) {
    if (settingsId) {
      const res = await this.templateModuleInstance.getBatchSettingsTemplates(settingsId)
      if (res) {
        const messages = res
            .filter((item: IBatchTemplate) => item.type === ETemplateType.MESSAGE)
            .map((item: IBatchTemplate) => {
              return {
                ...item,
                // @ts-ignore
                template: item.template && item.template.id ? item.template.id : null
              }
            })
        // .filter((item: IBatchTemplate) => item.type === ETemplateType.LETTER_PDF || item.type === ETemplateType.LETTER)
        const letters = res
            .filter((item: IBatchTemplate) => item.type === ETemplateType.LETTER_PDF || item.type === ETemplateType.LETTER)
            .map((item: IBatchTemplate) => {
              return {
                ...item,
                // @ts-ignore
                template: item.template && item.template.id ? item.template.id : null,
                type: item.type
              }
            })

        if (messages.length) {
          this.messageTemplatesList = messages
        } else if (!this.messageTemplatesList.length) {
          this.addEmptyMessageTemplate()
        }
        if (letters.length) {
          this.letterTemplatesList = letters
        } else if (!this.letterTemplatesList.length) {
          this.addEmptyLetterTemplate()
        }
        this.$emit('setBatchTemplates', messages.concat(letters))
      }
    } else {
      if (!this.letterTemplatesList.length) this.addEmptyLetterTemplate()
      if (!this.messageTemplatesList.length) this.addEmptyMessageTemplate()
      this.$emit('setBatchTemplates', [])
    }
  }

  openConditionModal (index: number, type: 'LETTER' | 'MESSAGE') {
    this.selectedTemplate = this.letterTemplatesList[index]
    this.selectedTemplate = type === 'MESSAGE'
        ? this.messageTemplatesList[index]
        : this.letterTemplatesList[index]
    this.$nextTick(() => {
      this.toggleConditionModal(true)
    })
  }

  toggleConditionModal (value: boolean) {
    this.letterConditionModal = value
  }

  addEmptyLetterTemplate () {
    this.letterTemplatesList.push(Object.assign({}, this.emptyLetterObj))
  }

  async selectPDFLetterToUpload (item: any): Promise<any> {
    if (!item) {
      this.fileName = ''
      // @ts-ignore
      this.$refs['statementFile'].clear()
      return
    }
    this.isLoadingFile = true
    const res = await this.templateModuleInstance.uploadPDFLetter(item)
    if (typeof res === 'string') {
      const regex = /pdf-letters\/(.*)/gm
      this.fileName = res.replace(regex, '$1')
      // @ts-ignore
      let fileName = `ChainLetterPdf-${this.$refs['statementFile'].selectedFile}`
      await this.templateModuleInstance.addTemplate({
        type: ETemplateType.LETTER_PDF,
        level: ETemplateLevel.CHAIN,
        // @ts-ignore
        title: this.$refs['statementFile'].selectedFile,
        chain: this.chainModuleInstance.chain ? this.chainModuleInstance.chain.id : undefined,
        body: '',
        fileName: this.fileName,
        templateName: fileName
      })
      await this.templateModuleInstance.fetchTemplates({})
      const letter = this.lettersList[0]
      const index = this.letterTemplatesList.findIndex((el) => el.template === null)
      if (index === -1) {
        this.letterTemplatesList.push({
          id: letter.id,
          facilityId: this.$props.facilityId,
          settingsId: this.$props.settingsId ? this.$props.settingsId : null,
          template: letter.id,
          type: letter.type
        })
        this.save(this.letterTemplatesList[this.letterTemplatesList.length - 1], this.letterTemplatesList.length - 1, 'LETTER_PDF')
      } else {
        this.letterTemplatesList[index].template = letter.id
        this.letterTemplatesList[index].type = letter.type
        this.save(this.letterTemplatesList[index], index, 'LETTER_PDF')
      }
      this.$forceUpdate()
    }
    // @ts-ignore
    this.$refs['statementFile'].clear()
    this.isLoadingFile = false
  }

  addEmptyMessageTemplate () {
    this.messageTemplatesList.push(Object.assign({}, this.emptyMessageObj))
  }

  updateConditions ({ letterId, messageId, payload }: any) {
    if (letterId !== undefined) {
      this.updateLetterCondition(letterId, payload)
    } else {
      this.updateMessageCondition(messageId, payload)
    }
  }

  updateLetterCondition (letterId: number, payload: any) {
    const letterIndex = this.letterTemplatesList.findIndex((item: any) => item.id === letterId)
    if (letterIndex === -1) {
      return
    }
    this.letterTemplatesList[letterIndex] = {
      ...this.letterTemplatesList[letterIndex],
      ...payload
    }
    this.toggleConditionModal(false)
    this.save(this.letterTemplatesList[letterIndex], letterIndex, 'LETTER')
  }

  updateMessageCondition (messageId: number, payload: any) {
    const messageIndex = this.messageTemplatesList.findIndex((item: any) => item.id === messageId)
    if (messageIndex === -1) {
      return
    }
    this.messageTemplatesList[messageIndex] = {
      ...this.messageTemplatesList[messageIndex],
      ...payload
    }
    this.toggleConditionModal(false)
    this.save(this.messageTemplatesList[messageIndex], messageIndex, 'MESSAGE')
  }

  updateMessageTemplateValue (index: number, value: any) {
    if (value === this.ADD_MESSAGE_TRIGGER_VALUE) {
      this.openTemplateNewPage(this.ADD_MESSAGE_TRIGGER_VALUE)
      return
    }
    this.messageTemplatesList[index].template = value
    this.save(this.messageTemplatesList[index], index, 'MESSAGE')
  }

  updateLetterTemplateValue (index: number, value: any) {
    if (value === this.ADD_LETTER_TRIGGER_VALUE) {
      this.openTemplateNewPage(this.ADD_LETTER_TRIGGER_VALUE)
      return
    }
    const letter = this.lettersList.find((item: any) => item.id === value)
    this.letterTemplatesList[index].template = value
    this.letterTemplatesList[index].type = letter.type
    this.save(this.letterTemplatesList[index], index, letter.type)
    this.$forceUpdate()
  }

  openTemplateNewPage (type: string) {
    const route = this.$router.resolve({
      name: 'management-template',
      params: {
        templateId: 'new'
      },
      query: {
        type: type
      }
    })
    this.$locationManager.openNewTab(route.href, true)
  }

  removeMessageTemplate (index: number) {
    if (this.$props.enableBulkSave) {
      this.messageTemplatesList.splice(index, 1)
      this.saveBulk()
    } else {
      this.$emit('remove', this.messageTemplatesList[index])
      this.messageTemplatesList.splice(index, 1)
    }
    if (!this.messageTemplatesList.length) this.addEmptyMessageTemplate()
  }

  removeLetterTemplate (index: number) {
    if (this.$props.enableBulkSave) {
      this.letterTemplatesList.splice(index, 1)
      this.saveBulk()
    } else {
      this.$emit('remove', this.letterTemplatesList[index])
      this.letterTemplatesList.splice(index, 1)
    }
    if (!this.letterTemplatesList.length) this.addEmptyLetterTemplate()
  }

  save (template: Partial<IBatchTemplate>, index: number, type: 'LETTER' | 'MESSAGE' | 'LETTER_PDF') {
    if (this.$props.enableBulkSave) {
      this.saveBulk()
    } else {
      this.$emit('save', { batchTemplate: template, index, type })
    }
  }

  saveBulk () {
    const letters = this.letterTemplatesList.filter((item: Partial<IBatchTemplate>) => !!item.template)
    const messages = this.messageTemplatesList.filter((item: Partial<IBatchTemplate>) => !!item.template)
    const payload = letters.concat(messages)
    this.$emit('saveBulk', payload)
  }

  @NoCache
  get lettersList () {
    return this.$props.templateOptions
        .filter((template: ITemplate) => template.type === ETemplateType.LETTER_PDF || template.type === ETemplateType.LETTER)
    // .filter((template: ITemplate) => template.type === ETemplateType.LETTER_PDF)
  }

  get messagesList () {
    return this.$props.templateOptions
        .filter((template: ITemplate) => template.type === ETemplateType.MESSAGE)
  }

  get lettersListOptions () {
    const options = this.lettersList.map((template: ITemplate) => {
      return {
        key: template.id,
        value: template.id,
        content: template.templateName
      }
    })
    options.push({
      key: this.ADD_LETTER_TRIGGER_VALUE,
      value: this.ADD_LETTER_TRIGGER_VALUE,
      content: 'Add new +'
    })
    return options
  }

  get messagesListOptions () {
    const options = this.messagesList.map((template: ITemplate) => {
      return {
        key: template.id,
        value: template.id,
        content: template.templateName
      }
    })
    options.push({
      key: this.ADD_MESSAGE_TRIGGER_VALUE,
      value: this.ADD_MESSAGE_TRIGGER_VALUE,
      content: 'Add new +'
    })
    return options
  }

  mounted () {
    this.$watch('settingsId', (value: string | number) => {
      this.getBatchSettingsTemplates(value)
    }, { immediate: true })
  }
}
